import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useMemo, createElement } from 'react';
import { useHTMLProps } from '../html/use-props.mjs';
import { filterProps } from './utils/filter-props.mjs';
import { isSVGComponent } from './utils/is-svg-component.mjs';
import { useSVGProps } from '../svg/use-props.mjs';
import { isMotionValue } from '../../value/utils/is-motion-value.mjs';
function createUseRender() {
  var forwardMotionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var useRender = function useRender(Component, props, projectionId, ref, _ref, isStatic) {
    var latestValues = _ref.latestValues;
    var useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic, Component);
    var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    var elementProps = _objectSpread(_objectSpread(_objectSpread({}, filteredProps), visualProps), {}, {
      ref: ref
    });
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    var children = props.children;
    var renderedChildren = useMemo(function () {
      return isMotionValue(children) ? children.get() : children;
    }, [children]);
    if (projectionId) {
      elementProps["data-projection-id"] = projectionId;
    }
    return createElement(Component, _objectSpread(_objectSpread({}, elementProps), {}, {
      children: renderedChildren
    }));
  };
  return useRender;
}
export { createUseRender };